export default __webpack_public_path__ + "static/media/login.4a4c9c34.png";